var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "some" }, [
    _c("div", { class: [_vm.width === "post" ? "articleContainer" : ""] }, [
      _c("h2", [_vm._v("Jaa")]),
      _vm._v(" "),
      _c("img", { staticClass: "headingLine", attrs: { src: _vm.line } }),
      _vm._v(" "),
      _c("div", { staticClass: "icons" }, [
        _c(
          "a",
          {
            staticClass: "somelink",
            attrs: {
              href: _vm.fbUrl,
              target: "_blank",
              "aria-label": "Jaa Facebookissa"
            }
          },
          [
            _c("div", { staticClass: "iconWrap" }, [
              _c("img", {
                staticClass: "fbicon",
                attrs: { src: _vm.fbicon, alt: "Facebook" }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "somelink",
            attrs: {
              href: _vm.twitterUrl,
              target: "_blank",
              "aria-label": "Jaa Twitterissä"
            }
          },
          [
            _c("div", { staticClass: "iconWrap" }, [
              _c("img", {
                staticClass: "twittericon",
                attrs: { src: _vm.twittericon, alt: "Twitter" }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "somelink",
            attrs: {
              href: _vm.linkedinUrl,
              target: "_blank",
              "aria-label": "Jaa LinkedInissä"
            }
          },
          [
            _c("div", { staticClass: "iconWrap" }, [
              _c("img", {
                staticClass: "linkedinicon",
                attrs: { src: _vm.linkedinicon, alt: "LinkedIn" }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "somelink",
            attrs: { href: _vm.shareUrl, "aria-label": "Jaa sähköpostilla" }
          },
          [
            _c("div", { staticClass: "iconWrap" }, [
              _c("img", {
                staticClass: "mailicon",
                attrs: { src: _vm.emailicon, alt: "" }
              })
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }